<template>
  <div class="container download-discount-block">
    <button class="button" @click.prevent="downloadDiscountFile()">{{ $t('download_discount') }}</button>
  </div>
</template>

<script>
import { downloadFile } from "@/helpers";

export default {
  methods: {
    downloadDiscountFile() {
      downloadFile(this, '/order/user-order/download-all-discounts/');
    },
  }
}
</script>

<i18n lang="yaml">
ru:
  download_discount: 'Скачать скидки'
en:
  download_discount: 'Download discounts'
</i18n>